import React, { useState, useContext } from 'react';
import './Banner.scss';
import {Link} from 'react-router-dom';
import icon from '../../assets/banner/icons/Calling.png';
import bannerImg from '../../assets/newmonaassets/image_samet_tall.png';
import doctorImg from '../../assets/newmonaassets/image_samet_head.png';
import bannerPattern from '../../assets/banner/pattern_02.png';
import shapeOne from '../../assets/banner/vector_01.png';
import shapeTwo from '../../assets/banner/vector_02.png';
import shapeThree from '../../assets/banner/vector_03.png';
import shapeFour from '../../assets/banner/pattern.png';
import { LanguageContext } from '../../context/LanguageContext';
import OptimizedImage from '../../components/OptimizedImage';
import useAnalytics from '../../hooks/useAnalytics';

// Mobil ve tablet için optimize edilmiş görüntüler
// Not: Gerçek projede bu dosyaları oluşturun veya mevcut dosyaları kullanın
const bannerImgMobile = bannerImg; // Mobil için optimize edilmiş görüntü
const bannerImgTablet = bannerImg; // Tablet için optimize edilmiş görüntü
const doctorImgMobile = doctorImg; // Mobil için optimize edilmiş görüntü

const Banner = () => {
    const { t } = useContext(LanguageContext);
    const [currentLang] = useState('tr');  // Navbar'dan alacağız
    const { trackEvent, trackContactInteraction } = useAnalytics();

    const content = {
        tr: {
            title: "Gülüşünüzü Uzmanlara Emanet Edin",
            description: "Modern diş hekimliği teknikleri ve uzman kadromuzla, size özel tedavi planlaması yapıyor, gülüşünüzü tasarlıyoruz. Konforlu ve steril ortamımızda, en son teknoloji ile hizmet veriyoruz.",
            appointmentButton: "Randevu Al",
            workingHours: "Çalışma Saatleri: 09:00 - 23:00",
            doctorTitle: "Diş Hekimi"
        },
        en: {
            title: "Trust Your Smile to Professionals",
            description: "With our modern dentistry techniques and expert staff, we create personalized treatment plans and design your smile. We provide service with the latest technology in our comfortable and sterile environment.",
            appointmentButton: "Book Appointment",
            workingHours: "Working Hours: 09:00 - 23:00",
            doctorTitle: "Dentist"
        }
    };

    // Telefon numarası
    const phoneNumber = "05322944005";

    // Event handler'lar
    const handleAppointmentClick = () => {
        trackEvent('appointment_button_click', { source: 'banner' });
    };
    const handleCallClick = () => {
        trackContactInteraction('phone', '+905322944005');
        trackEvent('call_button_click', { source: 'banner' });
    };

    return (
        <section className='section-bg section-common banner-section'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="banner-text" data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
                                    <h1>{t('banner.title')}</h1>
                                    <p>{t('banner.description')}</p>

                                    <div className="banner-bottom">
                                        <div className="theme-btn">
                                            <Link to="/contact" onClick={handleAppointmentClick}>{content[currentLang].appointmentButton}</Link>
                                        </div>

                                        <div className="banner-call">
                                            <a href={`tel:${phoneNumber}`} className="banner-call-wrapper" onClick={handleCallClick}>
                                                <div className='icon'>
                                                    <OptimizedImage 
                                                        src={icon} 
                                                        alt={t('altText.call')} 
                                                        lazy={false} // Görünür alanda olduğu için lazy loading kapalı
                                                    />
                                                </div>
                                                <div className='call-text'>
                                                    <p>{content[currentLang].workingHours}</p>
                                                    <h6>+90 0532 294 40 05</h6>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="banner-img-area" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                    <div className="banner-img">
                                        <OptimizedImage 
                                            src={bannerImg} 
                                            mobileSrc={bannerImgMobile}
                                            tabletSrc={bannerImgTablet}
                                            alt={t('altText.doctor')} 
                                            lazy={false} // Ana görsel olduğu için lazy loading kapalı
                                        />
                                    </div>
                                    <div className='info-box'>
                                        <div className="info-img">
                                            <OptimizedImage 
                                                src={doctorImg} 
                                                mobileSrc={doctorImgMobile}
                                                alt={t('altText.doctor')} 
                                                lazy={false} // Görünür alanda olduğu için lazy loading kapalı
                                            />
                                        </div>
                                        <div className='info-text'>
                                            <p>Dr. Samet Aksu</p>
                                            <p><small>{content[currentLang].doctorTitle}</small></p>
                                        </div>
                                    </div>  

                                    {/* Vector Shapes */}
                                    <div className="shapes">
                                        <OptimizedImage src={shapeOne} alt={t('altText.shape')} />
                                        <OptimizedImage src={shapeTwo} alt={t('altText.shape')} />
                                        <OptimizedImage src={shapeThree} alt={t('altText.shape')} />
                                        <OptimizedImage src={shapeFour} alt={t('altText.shape')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Banner Pattern Vector*/}
            <OptimizedImage 
                className='banner-pattern' 
                src={bannerPattern} 
                alt={t('altText.pattern')} 
            />
        </section>
    );
};

export default Banner;